import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import PreSaleStageIntro from './PreSaleStageIntro/presale.stage.intro.vue';
import { PresaleDetailDelegate } from '../../services/DataDelegate/PresaleDelegate/presale.detail.delegate';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import { countryInterpretor } from '../../utils/interpretor';
import { NoticeConfig } from 'iview';
import * as T_T from 'cryface';
import { PreSaleValidator } from './validator';
const myUpload = require('vue-image-crop-upload').default;

@Component({
    components: {
        Header,
        SpinLoader,
        NavSide,
        PreSaleStageIntro,
        'crop-uploader': myUpload
    }
})
export default class PreSaleStagePage extends Vue {
    public title: string = 'PreSaleStagePage';

    public isLoading = false;

    public isUploading = false;

    public id: string = 'new';

    public detailDelegate = new PresaleDetailDelegate();

    public commonConfig = new CommonConfig();

    public imgModalOne = false;

    public imgModalTwo = false;

    public userInfo = {
        id: 'N/A',
        name: '',
        phone: '',
        wechat: '',
    };

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public onAuthenticated(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            this.userInfo.id = val.id;
            this.userInfo.name = T_T.simpleDetect(val.partner.displayName) ? val.partner.displayName : '';
            this.userInfo.phone = T_T.simpleDetect(val.xPhone) ? val.xPhone : '';
            this.userInfo.wechat = T_T.simpleDetect(val.xWechat) ? val.xWechat : '';
        }
    }

    public model: any = {
        pictureOne: '',
        pictureTwo: '',
        title: '',
        fullAddress: '',
        country: 'Canada',
        province: 'Ontario',
        region: '',
        city: 'Toronto',
        bedrooms: '',
        bedroomsPlus: 0,
        washrooms: '',
        garages: '',
        parkingSpaces: '',
        price: '',
        address: {
            streetNumber: '',
            streetName: '',
            postalCode: '',
        },
        remark: '',
        storey: '',
        active: true,
    };

    public rules: any = {
        title: [
            { validator: PreSaleValidator.titleValidator, trigger: 'blur' }
        ],
        // price: [
        //     { validator: PreSaleValidator.priceValidator, trigger: 'blur' }
        // ],
        streetNumber: [
            { validator: PreSaleValidator.streetNumberValidator, trigger: 'blur' }
        ],
        streetName: [
            { validator: PreSaleValidator.streetNameValidator, trigger: 'blur' }
        ],
        postalCode: [
            { validator: PreSaleValidator.postalCodeValidator, trigger: 'blur' }
        ]
    };

    public countryList = [
        // {
        //     value: 'USA',
        //     label: 'USA'
        // },
        {
            value: 'Canada',
            label: 'Canada'
        },
    ];

    public provinceList = [
        {
            value: 'Ontario',
            label: 'Ontario'
        },
    ];

    public cityList = [
        {
            value: 'Toronto',
            label: 'Toronto'
        },
    ];

    public cropSuccessOne(imgDataUrl: any, field: any) {
        this.model.pictureOne = imgDataUrl;
    }

    public cropSuccessTwo(imgDataUrl: any, field: any) {
        this.model.pictureTwo = imgDataUrl;
    }

    public async created() {
        this.isLoading = true;
        this.id = this.$route.params.id;
        if (this.id !== 'new') {
            await this.getDetail();
        }
        this.isLoading = false;
    }

    public async getDetail() {
        const detailQuery = await this.detailDelegate.getStageDetail(this.id);
        if (detailQuery === 0) {
        } else {
            this.model = detailQuery;
        }
    }

    public async uploadAjax() {
        const successStageConfig: NoticeConfig = {
            title: 'Stage Succeed',
            desc: 'Succeed to post new pre-sale property.'
        };
        const successEditConfig: NoticeConfig = {
            title: 'Edit Succeed',
            desc: `Succeed to edit pre-sale property ${this.id}.`
        };
        this.isUploading = true;
        const apiHost = this.commonConfig.apiHost;
        // const apiHost = 'http://192.168.0.92:9528';
        const requestParams: any = {
            pictures: `${this.model.pictureOne},${this.model.pictureTwo}`,
            preConstructionName: this.model.title,
            country: countryInterpretor(this.model.country),
            province: this.model.province,
            city: this.model.city,
            ...(this.model.bedrooms && { bedrooms: this.model.bedrooms}),
            ...(this.model.bedroomsPlus && { bedroomsPlus: this.model.bedroomsPlus}),
            ...(this.model.washrooms && { washrooms: this.model.washrooms}),
            ...(this.model.garages && { garages: this.model.garages}),
            ...(this.model.price && { price: this.model.price}),
            ...(this.model.storey && { storey: this.model.storey}),
            streetNumber: this.model.streetNumber,
            streetName: this.model.streetName,
            postalCode: this.model.postalCode,
            remark: this.model.remark ? this.model.remark : '',
            active: this.model.active,
            ltype: 1,
            rifoPropertyType: 'development-second',
            agentId: this.userInfo.id,
        };
        if (this.id === 'new') { } else {
            requestParams.identifier = this.id;
        }
        // console.log(requestParams);
        const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/rifoListings/add`, requestParams);
        this.isUploading = false;
        if (this.id === 'new') {
            this.$Notice.success(
                successStageConfig
            );
        } else {
            this.$Notice.success(
                successEditConfig
            );
        }
    }
    public async handleUpload() {
        const self = this;
        const _ref: any = this.$refs.model;
        if (!this.model.pictureOne
            || !this.model.pictureTwo) {
                this.$Message.error('请上传图片');
                return;
        }
        _ref.validate(async (valid: any) => {
            if (valid) {
                await self.uploadAjax();
            } else {
                this.$Message.error('表单验证失败，请检查所填字段');
            }
        });
    }

}
